<template>
  <b-modal id="clinic-show-custom-schedule" class="customer-show-custom-schedule" ref="modal" :title="dialog_title"
    hide-footer>

    <div class="row form-group">
      <div class="col-sm-4">
        <input type="text" class="form-control" v-model="name" id="sched_name" placeholder="Nombre del calendario" />
        <label for="sched_name" class="wabident-info">Nombre del Calendario (Obligatorio)</label>
      </div>

      <div class="col-sm-4">
        <input type="date" class="form-control" v-model="date_from" id="sched_date_from" />
        <label for="sched_date_from" class="wabident-info">Desde (Obligatorio)</label>
      </div>

      <div class="col-sm-4">
        <input type="date" class="form-control" v-model="date_to" id="sched_date_to" />
        <label for="sched_date_to" class="wabident-info">Hasta (Obligatorio)</label>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-12">
        <h6>HORARIO</h6>
      </div>
    </div>

    <div v-for="(day, index) in hours_config.daily_hours" class="row form-group clinic-schedule__day" :key="index">
      <div class="col-sm-4">
        <div class="form-check form-check-inline">
          <input v-model="day.checked" class="form-check-input" type="checkbox" :id="'day_checked_' + index"
            :value="true" />
          <label class="form-check-label" :for="'day_checked_' + index">{{ day.name }}</label>
        </div>
      </div>

      <div class="col-sm-4 form-inline clinic-schedule__hours d-flex justify-content-start align-items-center gap-5">
        <input @change="setHourValue(day, 'morning_start', $event.target.value)"
          :value="getHourValue(day, day.morning_start)" class="form-control wabident-small" type="text"
          :readonly="!day.checked" placeholder="No" />
        —
        <input @change="setHourValue(day, 'morning_end', $event.target.value)"
          :value="getHourValue(day, day.morning_end)" class="form-control wabident-small" type="text"
          :readonly="!day.checked" placeholder="No" />
      </div>

      <div class="col-sm-4 form-inline clinic-schedule__hours  d-flex justify-content-start align-items-center gap-5">
        <input @change="setHourValue(day, 'afternoon_start', $event.target.value)"
          :value="getHourValue(day, day.afternoon_start)" class="form-control wabident-small" type="text"
          :readonly="!day.checked" placeholder="No" />
        —
        <input @change="setHourValue(day, 'afternoon_end', $event.target.value)"
          :value="getHourValue(day, day.afternoon_end)" class="form-control wabident-small" type="text"
          :readonly="!day.checked" placeholder="No" />
      </div>
    </div>

    <div class="row form-group mt-4">
      <div class="col-12 d-flex align-items-center justify-content-around">
        <button @click="onDelete" :disabled="is_loading" v-if="is_editing" class="btn-wabident red">
          <i class="fas fa-trash"></i> Borrar
        </button>
        <button :disabled="!can_save" class="btn-wabident" @click="submit">
          <i class="fas fa-save"></i> Guardar
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      schedule_id: null,
      name: null,
      date_from: null,
      date_to: null,
      hours_config: {},
      is_loading: false,
    }
  },
  computed: {
    can_save() {
      return !this.is_loading && (this.name && this.name != '')
        && (this.date_from && this.date_from != '')
        && (this.date_to && this.date_to != '');
    },
    is_editing() {
      return this.schedule_id != null;
    },
    dialog_title() {
      return this.is_editing ? 'Editar Calendario' : 'Crear Calendario';
    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    showNew() {
      this.schedule_id = null;
      this.name = null;
      this.date_from = null;
      this.date_to = null;
      this.is_loading = false;

      this.hours_config = {
        daily_hours: [
          // Mon
          {
            name: 'Lunes',
            checked: true,
            morning_start: '09:00',
            morning_end: '14:00',
            afternoon_start: '16:00',
            afternoon_end: '20:00',
          },
          // Tues
          {
            name: 'Martes',
            checked: true,
            morning_start: '09:00',
            morning_end: '14:00',
            afternoon_start: '16:00',
            afternoon_end: '20:00',
          },
          // Wed
          {
            name: 'Miércoles',
            checked: true,
            morning_start: '09:00',
            morning_end: '14:00',
            afternoon_start: '16:00',
            afternoon_end: '20:00',
          },
          // Thur
          {
            name: 'Jueves',
            checked: true,
            morning_start: '09:00',
            morning_end: '14:00',
            afternoon_start: '16:00',
            afternoon_end: '20:00',
          },
          // Fri
          {
            name: 'Viernes',
            checked: true,
            morning_start: '09:00',
            morning_end: '14:00',
            afternoon_start: '',
            afternoon_end: '',
          },
          // Sat
          {
            name: 'Sábado',
            checked: false,
            morning_start: '',
            morning_end: '',
            afternoon_start: '',
            afternoon_end: '',
          },
          // Sat
          {
            name: 'Domingo',
            checked: false,
            morning_start: '',
            morning_end: '',
            afternoon_start: '',
            afternoon_end: '',
          },
        ],
      };

      this.$refs.modal.show();
    },
    showEdit(schedule) {
      this.schedule_id = schedule.id;
      this.name = schedule.name;
      this.date_from = schedule.date_from;
      this.date_to = schedule.date_to;
      this.hours_config = schedule.hours_config;
      this.is_loading = false;

      this.$refs.modal.show();
    },
    getHourValue(day, value) {
      return day.checked ? value : "";
    },
    setHourValue(day, value_code, value) {
      let d = moment(value, "HH:mm");
      if (value != "" && (!d.isValid() || d.minutes() > 59 || d.hours() > 23)) {
        this.msgwindow.error("La hora introducida no es válida");
      } else {
        day[value_code] = value;
      }
    },
    onDelete() {
      if (this.is_loading) {
        return;
      }

      const msg = 'El Calendario no se podrá recuperar una vez borrado. ¿Estás seguro de querer borrarlo?';
      this.errorwindow.show('Confirmación', msg, 'Borrar', 'Cancelar', () => {
        this.is_loading = true;
        const uri = `/clinic/${this.clinic.id}/custom_schedule/${this.schedule_id}`;

        axios.post(uri, {
          _method: 'delete',
        }).then((result) => {
          if (result.data.error) {
            this.errorwindow.show('Error', result.data.error);
          } else {
            this.$emit('submit');
            this.$refs.modal.hide();
          }
        }).catch((error) => {
          this.msgwindow.error('Error Guardando Calendario. Por favor contacte con el Administrador');
          this.$emit('submit');
          this.$refs.modal.hide();
        }).then(() => {
          this.is_loading = false;
        });
      });
    },
    submit() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;
      const uri = this.is_editing ? `/clinic/${this.clinic.id}/custom_schedule/${this.schedule_id}` : `/clinic/${this.clinic.id}/custom_schedule`

      axios.post(uri, {
        name: this.name,
        date_from: this.date_from,
        date_to: this.date_to,
        hours_config: this.hours_config,
      }).then((result) => {
        if (result.data.error) {
          this.errorwindow.show('Error', result.data.error);
        } else {
          this.$emit('submit');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        this.msgwindow.error('Error Guardando Calendario. Por favor contacte con el Administrador');
        this.$emit('submit');
        this.$refs.modal.hide();
      }).then(() => {
        this.is_loading = false;
      });
    }
  }
}
</script>

<style lang="scss">
#clinic-show-custom-schedule {
  .modal-dialog {
    max-width: 768px;
  }

  .wabident-small {
    padding: 12px 10px;
    max-width: 75px;
  }

  .clinic-schedule__hours {
    flex-flow: row nowrap;
  }
}
</style>
